import { render } from "./Cloture.vue?vue&type=template&id=51f1f069&scoped=true"
import script from "./Cloture.vue?vue&type=script&lang=js"
export * from "./Cloture.vue?vue&type=script&lang=js"

import "./Cloture.vue?vue&type=style&index=0&id=51f1f069&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f1f069"]])

export default __exports__